import * as React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Button

} from '@mui/material';
import Checkbox from './Checkbox';
import api from "../services/api";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStoreActions } from "easy-peasy";
import { useForm } from "react-hook-form";

const BootstrapDialogTitle = () => {

  return (
    <DialogTitle sx={{ m: 0, p: 2 }}>
    </DialogTitle>
  );
};

const DialogoTermo = ({file}) => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let setUser = useStoreActions((actions) => actions.auth.setUser);
  const [aceite, setAceite] = React.useState(false);
  const [doc, setDoc] = React.useState(null);
  const [openDlgVis, setOpenDlgVis] = React.useState(true);

  const schema = yup.object({
    aceite: yup.boolean().label('Aceito o termo de confidencialidade')
  });

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
    defaultValues: {
      aceite: aceite
    }
  });

  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  React.useEffect( () => {
    let mount = {
      isMounted: true,
    };
    loadDocumentos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  const loadDocumentos = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get("/configs")).data;
      if (mount.isMounted) setDoc(data.doc);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  const src = () => {
    const API_URL_BASE = process.env.REACT_APP_API_URL_BASE;
    return API_URL_BASE + doc.fileRef;
  };

  const content = () => {
    if(doc) {
      if (doc.mimeType=='application/pdf' ||
          doc.mimeType=='text/html' ) {
        return (
          <iframe src={src()} frameBorder="0" width="100%" height="500"></iframe>
        );
      } else if(doc.mimeType.indexOf('image')==0) {
        return (
          <img src={src()} className="img-responsive" />
        );
      }
    }

    return '';
  };

  const submit = async () => {
    startLoading();
    try {
      setUser((await api.http.put('termo')).data);
      stopLoading({ severity: 'success' });
      reset({ keepValues: true});
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    <Dialog
      open={openDlgVis}
      maxWidth="lg"
      fullWidth={true}>
      <BootstrapDialogTitle id="customized-dialog-title">
        {doc?.fileName}
      </BootstrapDialogTitle>
      <DialogContent className="file-viewer">
        {content()}
      </DialogContent>
     
      <form onSubmit={handleSubmit(submit)}>
        <FormControl  sx={{ mx: 3, mb: 3}} >
          <Checkbox field={'aceite'}
                  schema={schema} useFormRef={useFormRef} />

          <Box>
            <Button type="submit" variant="contained" disabled={!isDirty || isSubmitting}
                 >Aceitar</Button>
          </Box>
        </FormControl>
      </form>
   
    </Dialog>
  );
};

export default DialogoTermo;
